/**
 * ═══════════════════════════════════════════════════════════════════════════
 *  AKIŲ FOTOGRAFIJA · PostHog universalūs event'ai
 * ═══════════════════════════════════════════════════════════════════════════
 *
 *  Ką seka automatiškai:
 *  1. Cart AJAX actions (add / update / remove / change) — Shopify /cart/*.js
 *  2. Checkout CTA (paspaudimas ant "Įdėti į krepšelį" / "Atsiskaityti")
 *  3. Produktų opcijų pasirinkimai (packaging, people, format, size) —
 *     per `data-track-*` attribute'us ARBA .pdp-swatch / .pdp-drawer-option
 *  4. Form submit'ai (newsletter, contact, email capture) — capture'ina
 *     event'ą + identify'ina jei form'oje yra email
 *  5. Coupon editorial tab switch (fizinis ↔ elektroninis)
 *  6. Accordion open (FAQ / produktų aprašymai) — kas domina lankytoją
 *
 *  Visi event'ai turi vienodus property naming patterns → lengva
 *  analizuoti su PostHog Max AI ("kiek žmonių pasirinko stiklą?", etc.)
 * ═══════════════════════════════════════════════════════════════════════════
 */

(function(){
  'use strict';

  function ph() { return window.posthog; }
  function capture(name, props) {
    try {
      if (!ph() || typeof ph().capture !== 'function') return;
      ph().capture(name, props || {});
    } catch(e) { /* silently ignore */ }
  }

  // ─────────────────────────────────────────────────────────────────
  //  1. SHOPIFY CART AJAX INTERCEPTOR
  //     Visos Shopify theme'os naudoja /cart/add.js, /cart/change.js,
  //     /cart/update.js, /cart/clear.js — patchinam fetch + XMLHttpRequest.
  // ─────────────────────────────────────────────────────────────────

  var originalFetch = window.fetch;
  if (originalFetch) {
    window.fetch = function(input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = (init && init.method) || (typeof input !== 'string' && input.method) || 'GET';

      var promise = originalFetch.apply(this, arguments);

      if (url.indexOf('/cart/') !== -1 && method.toUpperCase() !== 'GET') {
        promise.then(function(resp){
          var cloned = resp.clone();
          cloned.json().then(function(data){
            handleCartEvent(url, data, init);
          }).catch(function(){});
        }).catch(function(){});
      }

      return promise;
    };
  }

  function handleCartEvent(url, data, init) {
    try {
      if (url.indexOf('/cart/add') !== -1) {
        var item = (data && data.items && data.items[0]) || data || {};
        capture('cart_added', {
          product_id: item.product_id,
          variant_id: item.variant_id,
          product_title: item.product_title || item.title,
          variant_title: item.variant_title,
          quantity: item.quantity || 1,
          price: (item.price || 0) / 100,
          final_price: (item.final_price || item.price || 0) / 100,
          sku: item.sku,
          vendor: item.vendor,
          product_type: item.product_type,
          properties: item.properties || {}
        });
      } else if (url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1) {
        capture('cart_updated', {
          cart_total: (data.total_price || 0) / 100,
          items_count: data.item_count || 0,
          items: (data.items || []).map(function(i){
            return { product_id: i.product_id, variant_id: i.variant_id, qty: i.quantity, title: i.title };
          })
        });
      } else if (url.indexOf('/cart/clear') !== -1) {
        capture('cart_cleared', {});
      }
    } catch(e) {}
  }

  // ─────────────────────────────────────────────────────────────────
  //  2. CHECKOUT CTA
  //     Bet kuris link/button, kuris veda į /checkout arba /cart
  // ─────────────────────────────────────────────────────────────────

  document.addEventListener('click', function(e){
    var a = e.target.closest('a, button');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    var classes = (a.className || '').toString().toLowerCase();
    var txt = (a.textContent || '').trim().toLowerCase();

    if (href.indexOf('/checkout') !== -1 || classes.indexOf('checkout') !== -1 || txt === 'atsiskaityti' || txt === 'checkout') {
      capture('checkout_started', {
        cta_text: a.textContent.trim().slice(0, 60),
        cta_location: guessLocation(a)
      });
    }

    // Add to cart CTA — ant bet kurio mygtuko, kuris sako "įdėti į krepšelį" etc.
    if (txt.indexOf('įdėti į krepšelį') !== -1 || txt.indexOf('add to cart') !== -1 || a.matches('[name="add"]') || classes.indexOf('add-to-cart') !== -1) {
      capture('add_to_cart_clicked', {
        cta_text: a.textContent.trim().slice(0, 60),
        cta_location: guessLocation(a)
      });
    }
  }, { passive: true });

  function guessLocation(el) {
    var section = el.closest('[id^="shopify-section-"]');
    if (section) return section.id.replace('shopify-section-', '');
    var landmarks = ['header', 'main', 'footer', 'nav', 'aside'];
    for (var i = 0; i < landmarks.length; i++) {
      if (el.closest(landmarks[i])) return landmarks[i];
    }
    return 'unknown';
  }

  // ─────────────────────────────────────────────────────────────────
  //  3. PRODUKTŲ OPCIJŲ PASIRINKIMAI
  //     Veikia su `data-track-*` attribute'ais ARBA kai click'ina ant
  //     .pdp-swatch (packaging) / .pdp-drawer-option (people/format/size).
  // ─────────────────────────────────────────────────────────────────

  document.addEventListener('click', function(e){
    var t = e.target.closest('[data-track-event]');
    if (t) {
      var evt = t.getAttribute('data-track-event');
      var props = {};
      Array.from(t.attributes).forEach(function(a){
        if (a.name.indexOf('data-track-prop-') === 0) {
          var key = a.name.replace('data-track-prop-', '').replace(/-/g, '_');
          props[key] = a.value;
        }
      });
      capture(evt, props);
      return;
    }

    // Packaging swatch (Fizinis / Elektroninis)
    var swatch = e.target.closest('.pdp-swatch[data-packaging]');
    if (swatch) {
      capture('product_option_selected', {
        option_type: 'packaging',
        option_value: swatch.getAttribute('data-packaging')
      });
    }

    // Drawer opcijos (people / format / size)
    var drawerOpt = e.target.closest('.pdp-drawer-option[data-drawer-select]');
    if (drawerOpt) {
      capture('product_option_selected', {
        option_type: drawerOpt.getAttribute('data-drawer-select'),
        option_value: drawerOpt.getAttribute('data-value')
      });
    }

    // Accordion chips (inline accordion variantas)
    var chip = e.target.closest('.pdp-acc-chip[data-key]');
    if (chip) {
      capture('product_option_selected', {
        option_type: chip.getAttribute('data-key'),
        option_value: chip.getAttribute('data-value')
      });
    }

    // Coupon tab switch (fizinis ↔ elektroninis editorial view)
    var coupTab = e.target.closest('.gp-cpv-tab[data-cpv]');
    if (coupTab) {
      capture('coupon_tab_switched', {
        tab: coupTab.getAttribute('data-cpv')
      });
    }
  }, { passive: true });

  // ─────────────────────────────────────────────────────────────────
  //  4. FORM SUBMIT'AI + EMAIL CAPTURE (identify)
  // ─────────────────────────────────────────────────────────────────

  document.addEventListener('submit', function(e){
    var form = e.target;
    if (!form || !form.matches) return;

    var formName = form.getAttribute('data-posthog-form')
                 || form.getAttribute('id')
                 || form.getAttribute('action')
                 || 'unknown';

    var props = {
      form_name: formName,
      form_action: form.getAttribute('action') || '',
      form_location: guessLocation(form)
    };

    // Emails captured — identify the user
    var emailInput = form.querySelector('input[type="email"]');
    if (emailInput && emailInput.value) {
      var email = emailInput.value.trim().toLowerCase();
      try {
        if (ph() && typeof ph().identify === 'function') {
          ph().identify(email, { email: email });
        }
      } catch(e) {}
      props.email_captured = true;
      capture('email_captured', { email: email, form: formName });
    }

    // Newsletter heuristic
    if (formName.toLowerCase().indexOf('newsletter') !== -1 ||
        formName.toLowerCase().indexOf('contact_form') !== -1 ||
        (form.getAttribute('action') || '').indexOf('/contact') !== -1) {
      capture('newsletter_subscribed', props);
    } else {
      capture('form_submitted', props);
    }
  }, { passive: true, capture: true });

  // ─────────────────────────────────────────────────────────────────
  //  5. ACCORDION OPEN (FAQ / produkto aprašymas)
  //     Kas domina žmones — kuriuos klausimus atsidaro labiausiai.
  // ─────────────────────────────────────────────────────────────────

  document.addEventListener('click', function(e){
    var item = e.target.closest('.faq-item, .pdp-desc-item, .pdp-acc-item');
    if (!item) return;
    // Fires AFTER click handler toggles 'open' — small delay
    setTimeout(function(){
      if (!item.classList.contains('open')) return;
      var q = item.querySelector('.faq-q, .pdp-desc-q, .pdp-acc-label');
      var question = q ? q.textContent.trim().slice(0, 120) : '';
      var kind = item.classList.contains('faq-item') ? 'faq'
               : item.classList.contains('pdp-acc-item') ? 'option_drawer'
               : 'product_desc';
      capture('accordion_opened', {
        kind: kind,
        question: question
      });
    }, 50);
  }, { passive: true });

  // ─────────────────────────────────────────────────────────────────
  //  6. SCROLL DEPTH (25% / 50% / 75% / 100%)
  //     Paprastas engagement signalas.
  // ─────────────────────────────────────────────────────────────────

  (function(){
    var thresholds = [25, 50, 75, 100];
    var fired = {};
    function onScroll(){
      var h = document.documentElement;
      var pct = Math.round(((h.scrollTop + window.innerHeight) / h.scrollHeight) * 100);
      thresholds.forEach(function(t){
        if (pct >= t && !fired[t]) {
          fired[t] = true;
          capture('scroll_depth_reached', { depth_percent: t });
        }
      });
    }
    var throttled, timer;
    window.addEventListener('scroll', function(){
      if (timer) return;
      timer = setTimeout(function(){ timer = null; onScroll(); }, 250);
    }, { passive: true });
  })();

  // ─────────────────────────────────────────────────────────────────
  //  Export — leidžia custom kodui kviesti capture() su konsistentišku prefix'u
  //  Pvz. window.afTrack('studio_selected', { city: 'Vilnius' })
  // ─────────────────────────────────────────────────────────────────

  window.afTrack = capture;
})();
